import { Box, Grid, Tooltip } from '@mui/material';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SCUICustomDataGrid } from '../../../../atomic/molecules';
import { CustomerCommand } from '../../../../services/command';
import TimeHelper from '../../../../utils/time';
import { UAFP } from './userAccountFollowPaper.classes';

interface IProps {
    datas?: any;
}
export const UserAccountFollowPaper: FC<IProps> = ({ datas }) => {
    const { t } = useTranslation();
    const [ipAddress, setIpAddress] = useState('');
    const [verificationPhone, setVerifacitionDate] = useState('');
    const GetCustomerVerificationDateAndIpAddress = async () => {
        let params: any = {};
        params.customerId = Number(datas.customer.customerId);
        params.phoneNumber = String(datas.customer.phoneNumber);

        CustomerCommand.GetCustomerVerificationDateAndIpAddress(params)
            .then((res: any) => {
                setIpAddress(res.data.ipAddress);
                setVerifacitionDate(res.data.phoneValidetionDate);
            })
            .finally(() => {});
    };

    useEffect(() => {
        GetCustomerVerificationDateAndIpAddress();
    }, []);

    const rows: any = [
        {
            id: 1,
            createDate: TimeHelper.formatDateHour(datas.customer?.createTime),
            visitCustomer: datas.customer.infoCreateTime
                ? TimeHelper.formatDateHour(datas.customer?.infoCreateTime)
                : '-',
            ip: ipAddress,
            lastLoginDate: datas.customer?.lastLoginDate
                ? TimeHelper.formatDateHour(datas.customer?.lastLoginDate)
                : '-',
            checkPhone: verificationPhone ? TimeHelper.formatDateHour(verificationPhone) : '-',
            checkEmail: datas.customer?.emailConfirmedDate
                ? TimeHelper.formatDateHour(datas.customer?.emailConfirmedDate)
                : '-',
            masterpass: '-',
        },
    ];
    const columns: ExtendedGridColDef[] = [
        {
            field: 'createDate',
            renderHeader: () => {
                return t('customerInformation.createDate');
            },
            flex: 1,
            headerAlign: 'center',
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip title={TimeHelper.formatDateHour(datas.customer.createTime)}>
                            <p>{params.row.createDate}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'visitCustomer',
            renderHeader: () => {
                return t('customerInformation.visitCustomerDate');
            },
            flex: 1,
            headerAlign: 'center',
        },
        {
            field: 'ip',
            renderHeader: () => {
                return t('customerInformation.lastIp');
            },
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip title={<h2>{params.row.ip}</h2>}>
                            <p>{params.row.ip}</p>
                        </Tooltip>
                    </div>
                );
            },
            flex: 1,
            headerAlign: 'center',
        },
        {
            field: 'lastLoginDate',
            renderHeader: () => {
                return t('customerInformation.lastLogIn');
            },
            flex: 1,
            headerAlign: 'center',
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip title={params.row.lastLoginDate ? params.row.lastLoginDate : '-'}>
                            <p>{params.row.lastLoginDate}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'checkPhone',
            renderHeader: () => {
                return t('customerInformation.phoneValidationDate');
            },
            flex: 1,
            headerAlign: 'center',
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip title={TimeHelper.formatDateHour(verificationPhone)}>
                            <p>{params.row.checkPhone}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'checkEmail',
            renderHeader: () => {
                return t('customerInformation.emailValidationDate');
            },
            flex: 1,
            headerAlign: 'center',
        },
        {
            field: 'masterpass',
            renderHeader: () => <p>{t('customerInformation.masterpass')}</p>,
            flex: 1,
        },
    ];

    return (
        <Grid
            className={UAFP.page}
            sx={{ padding: '8px' }}
            size={{
                xl: 12,
                lg: 12,
                md: 12,
                xs: 12,
            }}
        >
            <Box className={UAFP.datagrid}>
                <SCUICustomDataGrid rows={rows} columns={columns} hideFooter />
            </Box>
        </Grid>
    );
};
